import React from "react";
import BackArrowButton from "../parts/back-arrow-button";
import LoginWrapper from "./LoginWrapper";
import SvgIcon from "../parts/SvgIcon";

class SignupPasswordView extends React.Component {
  constructor(props, ctx) {
    super(props, ctx);
    this.state = {
      passwordType: "password",
      confirmPasswordType: "password",
    };
    this.changePasswordType = this.changePasswordType.bind(this);
  }

  componentDidMount() {
    document.querySelector('input[name="passwordSignup"]').focus();
  }

  changePasswordType(e, input) {
    e.preventDefault();

    if (input === "password") {
      if (this.state.passwordType === "password") {
        this.setState({ passwordType: "text" });
        return;
      }
      return this.setState({ passwordType: "password" });
    } else {
      if (this.state.confirmPasswordType === "password") {
        this.setState({ confirmPasswordType: "text" });
        return;
      }
      return this.setState({ confirmPasswordType: "password" });
    }
  }

  render() {
    const { onBack, handleSignupPwd, handleFieldChange } = this.props;

    return (
      <LoginWrapper
        mainClass="Onboarding athlete"
        left={
          <form method="POST" data-noreset onSubmit={handleSignupPwd}>
            <BackArrowButton onBack={(_) => onBack(0)} />
            <div>
              <h1>Create password</h1>
            </div>

            <div className="input-password-wrapper">
              <label htmlFor="password">Password</label>
              <input
                type={this.state.passwordType}
                name="passwordSignup"
                required
                onChange={handleFieldChange}
                placeholder="Enter password here"
                sz="large"
              />
              <button
                data-button-type="text-white"
                data-icon-only=""
                onClick={(e) => this.changePasswordType(e, "password")}
                tabIndex="-1"
                type="button"
              >
                <SvgIcon
                  src={
                    this.state.passwordType === "password"
                      ? "/img/new-icons/eye.svg"
                      : "/img/new-icons/eye-slash.svg"
                  }
                  alt="eye"
                />
              </button>
            </div>
            <div className="input-password-wrapper">
              <label htmlFor="password">Confirm Password</label>
              <input
                type={this.state.confirmPasswordType}
                name="confirmPasswordSignup"
                required
                onChange={handleFieldChange}
                placeholder="Enter password here"
                sz="large"
              />
              <button
                data-button-type="text-white"
                data-icon-only=""
                onClick={(e) => this.changePasswordType(e, "confirm-password")}
                tabIndex="-1"
                type="button"
              >
                <SvgIcon
                  src={
                    this.state.confirmPasswordType === "password"
                      ? "/img/new-icons/eye.svg"
                      : "/img/new-icons/eye-slash.svg"
                  }
                  alt="eye"
                />
              </button>
            </div>

            <div className="chip info mt-2">
              Your password must have a minimum of 6 characters
            </div>

            <button
              data-button-type="primary"
              sz="large"
              onClick={handleSignupPwd}
            >
              Continue
            </button>
          </form>
        }
      />
    );
  }
}

export default SignupPasswordView;
